export type Community = {
    id: string;
    name: string;
    logoUrl: string;
};

export const communityParser = (comm: any): Community => {
    return {
        id: comm.id,
        name: comm.name,
        logoUrl: comm.photo_url,
    };
};

export const suggestionParser = (inputData: Record<string, any[]>): Community[] => {
    return inputData["topics"].map((comm) => communityParser(comm));
};
